import { useState } from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
    Box, VStack, Text, Button, FormControl, FormLabel, Select, Textarea, useToast
} from '@chakra-ui/react';
import AsyncSelect from 'react-select/async';
import { authAPI } from '../services/api';

const loadStudents = (input) =>
    authAPI.getStudents({ search: input, limit: 20 })
        .then(res => res.data.map(s => ({
            value: s.id,
            label: `${s.full_name} (${s.class?.name || '未分班'})`
        })));

const LeaveBatchModal = ({ isOpen, onClose, selectedDates, onSuccess }) => {
    const toast = useToast();
    const [batchStudent, setBatchStudent] = useState(null);
    const [batchType, setBatchType] = useState('PERSONAL');
    const [batchReason, setBatchReason] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleClose = () => { setBatchStudent(null); setBatchType('PERSONAL'); setBatchReason(''); onClose(); };

    const handleSubmit = async () => {
        if (!batchStudent || selectedDates.size === 0) return;
        setSubmitting(true);
        try {
            await authAPI.leaves.batchCreate({
                student_id: batchStudent.value,
                dates: Array.from(selectedDates),
                type: batchType,
                reason: batchReason
            });
            toast({ title: `已為 ${batchStudent.label} 登記 ${selectedDates.size} 天請假`, status: 'success' });
            setBatchStudent(null); setBatchType('PERSONAL'); setBatchReason('');
            onSuccess();
            onClose();
        } catch (e) {
            toast({ title: '登記失敗', description: e.response?.data?.detail, status: 'error' });
        } finally { setSubmitting(false); }
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>批量登記請假</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4}>
                        <Box w="100%" bg="red.50" p={3} borderRadius="md" border="1px solid" borderColor="red.200">
                            <Text fontSize="sm" color="red.700" fontWeight="bold" mb={1}>
                                已選日期（{selectedDates.size} 天）
                            </Text>
                            <Text fontSize="xs" color="red.600" lineHeight="tall">
                                {Array.from(selectedDates).sort().join('　')}
                            </Text>
                        </Box>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm">選擇學生</FormLabel>
                            <AsyncSelect
                                loadOptions={loadStudents}
                                value={batchStudent}
                                onChange={setBatchStudent}
                                placeholder="輸入姓名搜尋..."
                                isClearable
                                noOptionsMessage={() => '輸入至少 1 個字開始搜尋'}
                                loadingMessage={() => '搜尋中...'}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </FormControl>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm">假別</FormLabel>
                            <Select value={batchType} onChange={e => setBatchType(e.target.value)}>
                                <option value="PERSONAL">事假</option>
                                <option value="SICK">病假</option>
                                <option value="OTHER">其他</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel fontSize="sm">備註</FormLabel>
                            <Textarea placeholder="原因說明..." value={batchReason} onChange={e => setBatchReason(e.target.value)} rows={2} />
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={handleClose}>取消</Button>
                    <Button colorScheme="red" isLoading={submitting} isDisabled={!batchStudent} onClick={handleSubmit}>
                        確認登記
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default LeaveBatchModal;
